export enum BuilderType {
	// Application builder types
	appTypeBuilder = 'app-type-builder',
	preApplicationBuilder = 'pre-application-builder',

	// Widget builder types
	widgetBuilder = 'widget-builder',
	productSelectionBuilder = 'product-selection-builder'
}
